import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html'
})
export class AlertComponent {
  @Input() type: string;

  @HostBinding('class') get hostClassList() {
    return `d-flex align-items-center text-${this.type || 'danger'}`;
  };
}
